var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{ref:"formGroup",class:[
    _vm.computeFileValidation ? 'is-filled' : '',
    _vm.isFocused ? 'is-focus' : '',
    _vm.isDisabled ? 'is-disabled' : '',
  ],attrs:{"id":_vm.groupId,"label":_vm.label,"label-for":_vm.id,"label-class":"form-label","description":_vm.description,"invalid-feedback":_vm.invalidFeedback,"state":_vm.state}},[_c('b-form-file',{ref:_vm.id,attrs:{"accept":_vm.accept,"required":_vm.isRequired,"placeholder":_vm.placeholder,"state":_vm.state,"form":_vm.form,"value":_vm.value,"disabled":_vm.isDisabled,"no-drop":""},on:{"input":(e) => _vm.updateInput(e),"change":(e) => _vm.localChangeFn(e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }